/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Hidden, PageGridContainer, Skeleton, breakpoints } from '@coursera/cds-core';

const styles = {
  wrapper: css`
    gap: var(--cds-spacing-150);
  `,
  contextualHelp: css`
    ${breakpoints.up('sm')} {
      padding-right: var(--cds-spacing-150);
    }
  `,
};

type Props = {
  loading: boolean;
  header?: React.ReactElement;
  cta?: React.ReactElement | null;
  skillCards?: React.ReactElement[];
};

export const SkillsFocusModule = ({ loading, header, cta, skillCards }: Props) => {
  if (!loading && skillCards && !skillCards?.length) {
    return null;
  }

  const placeholder = [...Array(7).keys()].map((i) => (
    <Grid item xs={1} key={i} data-testid="skill-card-placeholder">
      <Skeleton variant="text" width="100%" />
    </Grid>
  ));

  const moduleHeader = (
    <Grid item container xs={12} justifyContent="space-between">
      <Grid item xs={12} sm={6} css={styles.contextualHelp}>
        {header}
      </Grid>
      <Grid item xs="auto" component={Hidden} xsDown>
        {cta}
      </Grid>
    </Grid>
  );

  return (
    <PageGridContainer data-testid="enterprise-skills-module">
      <Grid item container xs={12} css={styles.wrapper}>
        {moduleHeader}
        {/* Display placeholders while loading */}
        <Grid container item xs={12} spacing={8}>
          {loading ? placeholder : skillCards}
        </Grid>
        {/* mobile cta button */}
        <Grid item xs={12} component={Hidden} smUp>
          {cta}
        </Grid>
      </Grid>
    </PageGridContainer>
  );
};

export default SkillsFocusModule;
